import { useEffect, useState } from "react";

interface UseProgressiveDisclosureProps {
  isCreatingACommunity: boolean;
  isNewOnboardingFlow: boolean;
  prefillEmail?: string;
}

interface UseProgressiveDisclosureReturn {
  // Reset functionality
  handleBackToOptions: () => void;
  resetProgressiveDisclosure: boolean;
  // Form state
  shouldShowAdditionalFields: boolean;
  shouldShowAllFields: boolean;
}

export const useProgressiveDisclosure = ({
  isNewOnboardingFlow,
  isCreatingACommunity,
  prefillEmail,
}: UseProgressiveDisclosureProps): UseProgressiveDisclosureReturn => {
  const [shouldShowAdditionalFields, setShouldShowAdditionalFields] =
    useState(false);
  const [shouldResetFormDisclosure, setShouldResetFormDisclosure] =
    useState(false);

  // Determine if we should show all fields (including additional ones)
  const shouldShowAllFields =
    !isNewOnboardingFlow || !isCreatingACommunity || shouldShowAdditionalFields;

  // Auto-show additional fields if email is prefilled in new onboarding flow
  useEffect(() => {
    if (isNewOnboardingFlow && isCreatingACommunity && prefillEmail) {
      setShouldShowAdditionalFields(true);
    }
  }, [isNewOnboardingFlow, isCreatingACommunity, prefillEmail]);

  // Reset progressive disclosure when back button is clicked
  useEffect(() => {
    if (shouldResetFormDisclosure) {
      setShouldShowAdditionalFields(false);
    }
  }, [shouldResetFormDisclosure]);

  const handleBackToOptions = () => {
    setShouldResetFormDisclosure(true);
    // Reset the flag after a brief moment to allow the effect to trigger
    setTimeout(() => setShouldResetFormDisclosure(false), 100);
  };

  return {
    // Form state
    shouldShowAdditionalFields,
    shouldShowAllFields,
    // Reset functionality
    handleBackToOptions,
    resetProgressiveDisclosure: shouldResetFormDisclosure,
  };
};
